import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'sistema/galerias',
		component: Base,
		children: [
			{
				path: '',
				name: 'GaleriasList',
				component: List,
				meta: {
					path: '/sistema/galerias',
					pai: 'Sistema',
					title: 'Admin - Galerias',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Galerias',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'GaleriasNovo',
				component: Form,
				meta: {
					path: '/sistema/galerias',
					pai: 'Sistema',
					title: 'Admin - Galerias - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Galerias',
						class: '',
						active: false,
						url: '/sistema/galerias'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'GaleriasEditar',
				component: Form,
				meta: {
					path: '/sistema/galerias',
					pai: 'Sistema',
					title: 'Admin - Galerias - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Galerias',
						class: '',
						active: false,
						url: '/sistema/galerias'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]